import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { AppContext } from '../services/app-context.service';
import { CustomAuthService } from '../services/custom-auth.service';
import { map, take } from 'rxjs/operators';

export const organizationInitializedGuard: CanActivateFn = () => {
    const router = inject(Router);
    const appContext = inject(AppContext);
    const authService = inject(CustomAuthService);
    // Use select() for synchronous signal access instead of toSignal(organizationId$)
    // toObservable (used by observe/organizationId$) emits asynchronously, causing a race condition
    // where the guard runs before the value is emitted after login sets the organizationId
    const organizationId = appContext.select('organizationId');

    console.log('[OrgGuard] Running organization guard');

    // If user is not authenticated, let the auth guard handle the redirect
    // This guard should only check for organization if the user IS authenticated
    return authService.isAuthenticated$.pipe(
        take(1),
        map(isAuthenticated => {
            console.log('[OrgGuard] isAuthenticated:', isAuthenticated, 'organizationId:', organizationId());

            // Not authenticated - let auth guard handle it
            if (!isAuthenticated) {
                console.log('[OrgGuard] User not authenticated, returning true to let auth guard handle it');
                return true;
            }

            // User is authenticated, check for organization
            if (!organizationId()) {
                console.log('[OrgGuard] No organizationId, redirecting to organization-not-found');
                return router.createUrlTree(['/organization-not-found']);
            }

            console.log('[OrgGuard] Organization found, allowing access');
            return true;
        })
    );
};
